// import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { formatCurrency } from '@/utils/currencyFormat';

import Text from '../Text';

interface TotalImpactProps {
  amount: number;
  text?: string;
}

const TotalImpact = ({ amount, text }: TotalImpactProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.amountContainer}>
        <Text style={styles.amount} fontWeight="900">
          {text ? `${text} ` : ''}
          {formatCurrency(amount)}
        </Text>
        {/* ToDO: Implement download donations */}
        {/* <MaterialCommunityIcons name="download-circle-outline" size={24} color="black" /> */}
      </View>
      <Divider style={styles.divider} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 18,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  amountContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 10
  },

  amount: {
    fontSize: 22,
    color: 'black',
    marginBottom: 25,
    marginTop: 22
  },

  divider: {
    width: '100%'
  }
});

export default TotalImpact;
